// src/features/asistencia-tecnica/routes.js
// Se hace spread en src/config/page-route.jsx ANTES de la ruta comodín `**`.
import React from 'react';
import CapacitacionesListPage from './capacitaciones/ui/pages/CapacitacionesListPage.jsx';
import CapacitacionFormPage from './capacitaciones/ui/pages/CapacitacionFormPage.jsx';
import CapacitacionDetallePage from './capacitaciones/ui/pages/CapacitacionDetallePage.jsx';
import VisitasListPage from './visitas/ui/pages/VisitasListPage.jsx';
import VisitaFormPage from './visitas/ui/pages/VisitaFormPage.jsx';
import VisitaDetallePage from './visitas/ui/pages/VisitaDetallePage.jsx';
import { CAPACITACIONES_PATH, VISITAS_PATH, AT_COOPCONFIG } from './constants';

export const asistenciaTecnicaRoutes = [
  {
    exact: true,
    path: `${CAPACITACIONES_PATH}/list`,
    title: 'Capacitaciones',
    coopconfig: AT_COOPCONFIG,
    component: () => <CapacitacionesListPage />,
  },
  {
    exact: true,
    path: `${CAPACITACIONES_PATH}/create`,
    title: 'Capacitaciones',
    coopconfig: AT_COOPCONFIG,
    component: () => <CapacitacionFormPage />,
  },
  {
    exact: true,
    path: `${CAPACITACIONES_PATH}/detail/:uuid`,
    title: 'Capacitaciones',
    coopconfig: AT_COOPCONFIG,
    component: () => <CapacitacionDetallePage />,
  },
  {
    exact: true,
    path: `${CAPACITACIONES_PATH}/edit/:uuid`,
    title: 'Capacitaciones',
    coopconfig: AT_COOPCONFIG,
    component: () => <CapacitacionFormPage />,
  },
  { exact: true, path: `${VISITAS_PATH}/list`, title: 'Visitas', coopconfig: AT_COOPCONFIG, component: () => <VisitasListPage /> },
  { exact: true, path: `${VISITAS_PATH}/create`, title: 'Visitas', coopconfig: AT_COOPCONFIG, component: () => <VisitaFormPage /> },
  {
    exact: true,
    path: `${VISITAS_PATH}/detail/:uuid`,
    title: 'Visitas',
    coopconfig: AT_COOPCONFIG,
    component: () => <VisitaDetallePage />,
  },
  { exact: true, path: `${VISITAS_PATH}/edit/:uuid`, title: 'Visitas', coopconfig: AT_COOPCONFIG, component: () => <VisitaFormPage /> },
];
export const asistenciaTecnicaMenuItem = {
  path: `${CAPACITACIONES_PATH}/list`,
  icon: 'fa fa-chalkboard-teacher',
  title: 'Asistencia Técnica',
  coopconfig: AT_COOPCONFIG,
  children: [
    { path: `${CAPACITACIONES_PATH}/list`, title: 'Capacitaciones' },
    { path: `${VISITAS_PATH}/list`, title: 'Visitas' },
  ],
};
